import React, { useState } from 'react'
import { FiEye, FiEyeOff } from 'react-icons/fi'

interface PasswordInputProps {
    value: string
    onChange: (value: string) => void
    placeholder?: string
    className?: string
    name?: string
    id?: string
    required?: boolean
    autoComplete?: string
    error?: string
}

const PasswordInput: React.FC<PasswordInputProps> = ({
    value,
    onChange,
    placeholder = "Enter your password",
    className = "",
    name = "password",
    id = "password",
    required = false,
    autoComplete = "current-password",
    error
}) => {
    const [showPassword, setShowPassword] = useState(false)

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value)
    }

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword)
    }

    return (
        <div className={`relative ${className}`}>
            <input
                id={id}
                name={name}
                type={showPassword ? 'text' : 'password'}
                value={value}
                onChange={handleInputChange}
                required={required}
                autoComplete={autoComplete}
                className={`block w-full px-4 py-4 text-base border-2 ${error
                    ? 'border-red-300 focus:border-red-500'
                    : 'border-gray-300 focus:border-gray-500 dark:border-gray-600 dark:focus:border-gray-400'
                    } rounded-2xl placeholder-gray-500 text-gray-900 bg-white focus:outline-none focus:ring-0 transition-colors duration-200 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400 pr-12`}
                placeholder={placeholder}
                style={{
                    fontFamily: showPassword ? 'inherit' : 'text-security-disc, -webkit-text-security-disc, monospace'
                } as React.CSSProperties & { WebkitTextSecurity?: string; MozTextSecurity?: string }}
            />

            {/* Eye Icon Toggle */}
            <button
                type="button"
                className="absolute inset-y-0 right-0 pr-4 flex items-center z-10 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-r-2xl transition-colors group"
                onClick={togglePasswordVisibility}
                aria-label={showPassword ? "Hide password" : "Show password"}
            >
                {showPassword ? (
                    <FiEyeOff className="h-5 w-5 text-gray-600 dark:text-gray-300 group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors" />
                ) : (
                    <FiEye className="h-5 w-5 text-gray-600 dark:text-gray-300 group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors" />
                )}
            </button>
        </div>
    )
}

export default PasswordInput